import { render, staticRenderFns } from "./InvoicePositionsTableCell.vue?vue&type=template&id=4df5a078&scoped=true"
import script from "./InvoicePositionsTableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicePositionsTableCell.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicePositionsTableCell.vue?vue&type=style&index=0&id=4df5a078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df5a078",
  null
  
)

export default component.exports